<template>
  <c-confirm
    ref="cover-modal"
    :tips="t('plvIA.answerCard.confirmCoverTips')"
    :ensure-txt="t('plvIA.answerCard.cover')"
    :cancel-txt="t('plvIA.common.cancel')"
    @ensure="handleEnsure"
    @cancel="$emit('hide')"
  />
</template>

<script>
import Locale from '@/mixins/locale';
import PopupConfirm from '@/components/popup/Confirm';

export default {
  components: {
    'c-confirm': PopupConfirm,
  },

  mixins: [Locale],

  props: {
    show: {
      type: Boolean,
      default: false,
    }
  },

  watch: {
    show: {
      immediate: true,
      handler(val) {
        this.toggle(val);
      }
    }
  },

  methods: {
    toggle(toShow) {
      const ref = this.$refs['cover-modal'];
      if (!ref) return;
      if (toShow) {
        ref.show();
      } else {
        ref.hide();
      }
    },

    handleEnsure() {
      this.$emit('ensure');
    }
  }
};
</script>
